module.exports = __webpack_public_path__ + "static/media/sucess_icon.c303ea2f.svg";